import {connect} from 'react-redux';
import C, {RequestTypes} from '../../constants';
import ResultsView from "../ui/ResultsView";
import {recordTestResults} from "../../store/actions";

const mapStateToProps = state => {
    return {
        points: state.questions.map(q => Number.parseInt(q.result)).reduce((a, b) => a + b),
        session: state.session,
        request: {
            type: RequestTypes.RECORD_SESSION,
            updateRecordId: state.awsTestRecordId,
            session: state.session,
            questions: state.questions
        }
    }
};

const mapDispatchToProps = dispatch => {
    return {
        updateSession(payload) {
            dispatch({
                type: C.UPDATE_SESSION,
                payload: payload
            })
        },
        submitResults(req) {
            dispatch(
                recordTestResults(req)
            )
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultsView)
